import { Grid } from '@mui/material';
import React from 'react';
import SbButton from '../../../components/Button';
import GetRatesContext from '../../../context/GetRates';
import { GetRatesContextType } from '../Type';
import { AppDispatch, RootStateType } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { getRates } from '../../../store/reducers/GetRates';
import { SHIPMENT_TYPES } from '../Constant';
import { useNavigate } from 'react-router';
import { RatesType } from '@Reducers/GetRates/Type';
import { getDefaultRates } from '@Reducers/GetRates/actions';

interface ActionsProps {
  onNext?: (event: React.SyntheticEvent) => void;
  isTarrifPricing: boolean;
}

function GetRatesAction({ isTarrifPricing }: ActionsProps): JSX.Element {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { token } = useSelector((state: RootStateType) => state.loginUser);
  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { name = '' } = organizationData || {};
  const { ratesInputHasError, ratesInput, boxes, chargeableWeight, userId, setReduxState } = React.useContext(
    GetRatesContext,
  ) as GetRatesContextType;

  function handleGetRates() {
    const { destination, destinationPinCode, pickup, shipmentType, weight, weightUnit, pickupPinCode } = ratesInput;
    const finalWeight = chargeableWeight > Number(weight) ? chargeableWeight : Number(weight);

    const obj: RatesType = {
      destination: { ...destination, pincode: destinationPinCode?.toString() },
      source: { ...pickup, pincode: pickupPinCode.toString() },
      shipmentType,
      weight: Number(weight),
      package: {
        box: boxes.map((box, ind) => ({
          weight: Number(box.weight) < 1 && ind === 0 ? finalWeight.toString() : box.weight.toString(),
          length: typeof box.length === 'string' ? parseInt(box.length) : box.length,
          width: typeof box.width === 'string' ? parseInt(box.width) : box.width,
          height: typeof box.height === 'string' ? parseInt(box.height) : box.height,
        })),
        unitOfMeasurement: weightUnit === 'kg' ? 'kg-cm' : 'lb-in',
      },
      document: shipmentType === SHIPMENT_TYPES[1].value,
      dropOff: true,
      incoterm: 'FOB',
    };

    setReduxState();

    if (token?._id) {
      if (isTarrifPricing) {
        dispatch(
          getRates([{ ...obj, rateFor: 'get-rates', organizationName: name === 'Cargo Solutions Network' }, true]),
        );
      } else {
        dispatch(
          getRates([
            { ...obj, userId, rateFor: 'get-rates', organizationName: name === 'Cargo Solutions Network' },
            false,
          ]),
        );
      }
    } else {
      dispatch(
        getDefaultRates([{ ...obj, rateFor: 'get-rates', organizationName: name === 'Cargo Solutions Network' }, true]),
      );
    }
  }
  const handleBack = () => {
    navigate('/login');
  };

  const { destination, weight } = ratesInput;

  return (
    <>
      <Grid
        container
        justifyContent={{
          xs: name === 'Cargo Solutions Network' ? 'center' : 'center',
          md: name === 'Cargo Solutions Network' ? 'center' : 'end',
        }}
        spacing={2}
        marginTop={'10px'}
        className="bg-white p-2"
      >
        <Grid container item xs={12} md={2.5} lg={2}>
          <SbButton
            onClick={handleGetRates}
            variant="contained"
            className="rounded-full w-full"
            style={{ height: '44px', zIndex: '2', whiteSpace: 'nowrap' }}
            disabled={
              name === 'Cargo Solutions Network'
                ? // eslint-disable-next-line no-extra-boolean-cast
                  !Boolean(destination.city && weight && destination.pincode)
                : ratesInputHasError
            }
          >
            Get Rates
          </SbButton>
        </Grid>
        <Grid item xs={12} md={2.5} lg={2}>
          <SbButton
            onClick={handleBack}
            variant="outlined"
            className="rounded-full w-full"
            style={{ height: '44px', zIndex: '2' }}
          >
            Back
          </SbButton>
        </Grid>
      </Grid>
    </>
  );
}

export default GetRatesAction;
